'use client';

import React, { useTransition } from 'react';
import { useRouter, usePathname } from '@/navigation';
import { cn } from '@lib/utils';
import { TrackedButton } from '@components/button';
import { useLocale } from 'next-intl';
import { toggleLanguage, getRedirectPath } from '@/utils';

function LangToggler({ mode }: { mode: 'dark' | 'light' }) {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const locale = useLocale();
  const pathname = usePathname();

  const onToggleLocale = () => {
    const nextLocale = toggleLanguage(locale);
    const nextPath = getRedirectPath(pathname);

    startTransition(() => {
      router.replace(nextPath, { locale: nextLocale });
    });
  };

  const className = cn(
    'box-border block h-[34px] w-[34px] rounded-[50%] border-[2px] text-center text-[10px] font-semibold leading-[30px] disabled:cursor-not-allowed',
    {
      dark: 'border-white text-white hover:border-[#FF142D] hover:text-[#FF142D]',
      light:
        'border-[#040435] text-[#040435] hover:border-[#FF142D] hover:text-[#FF142D]',
    }[mode],
  );

  const langaugeText = locale === 'en' ? 'ENG' : 'KOR';
  return (
    <TrackedButton
      label={`toggle-locale`}
      position="nav"
      className={className}
      onClick={onToggleLocale}
      disabled={isPending}
    >
      {langaugeText}
    </TrackedButton>
  );
}

export default LangToggler;
